
class gTagEvents {
  constructor() {
    this.delegateBody = new Delegate(document.body);
    this.bindEvents();
    this.observeDOMChanges();
    this.handleIntersects();
    this.interceptCartApi();
  }


  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="ga-send-select"]',
      this.handleSelectItem.bind(this)
    );
  }

  observeDOMChanges() {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.addedNodes.length) {
          this.handleIntersects();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
    });
  }

  handleIntersects() {
    const allIntersections = document.body.querySelectorAll(
      '[data-gtag-intersection][data-observed="false"]'
    );
    allIntersections.forEach((item) => {
      const observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        }
      );
      observer.observe(item);
      item.dataset.observed = "true";
    });
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let data = false;
        try {
          data = JSON.parse(
            entry.target.querySelector('script[type="application/ld+json"]')
              .textContent
          );
        } catch (e) { }
        if (!dataLayer || !data) return;

        const crawledData = this.crawlAndDecode(data, "item_name");
        data = crawledData ? crawledData : data;

        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
      }
    });
  }


  interceptCartApi() {
    const originalFetch = window.fetch; // Save the original fetch method
    const _this = this; // Reference to the current context

    window.fetch = async function (...args) {
      try {
        const [url] = args;

        // Check if the URL contains the specific paths to intercept
        if (url.includes(`/cart/add.js`)) {
          const response = await originalFetch.apply(this, args);
          const responseClone = response.clone(); // Clone the response for custom processing
          const json = await responseClone.json();
          _this.cartAdd(json); // Call custom cartAdd handler
          return response;
        } else if (url.includes(`/cart/clear.js`)) {
          _this.cartClear(); // Call custom cartClear handler
          return await originalFetch.apply(this, args);
        } else if (url.includes(`/cart/change.js`) || url.includes(`/cart/update.js`)) {
          const response = await originalFetch.apply(this, args);
          const responseClone = response.clone();
          const json = await responseClone.json();
          _this.cartUpdate(json); // Call custom cartUpdate handler
          return response;
        }

        // If the URL is not intercepted, run fetch normally
        return await originalFetch.apply(this, args);
      } catch (e) {
        console.error("Error in fetch interception:", e);
        return new Response(JSON.stringify({ error: true }), { status: 500 });
      }
    };
  }

  async cartAdd(cart) {
    cart.items ? this.productAdded(cart.items) : this.productAdded([cart]);
  }

  async cartUpdate(cart) {
    
    this.productAdded(this.updateItems(cart, cart.items_added));
    this.productsRemoved(this.updateItems(cart, cart.items_removed));
  }

  async cartClear() {
    const cart = await this.getCart();
    this.productsRemoved(cart.items);
  }

  async getCart() {
    try {
      const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      return await response.json();
    } catch (error) { }
  }

  updateItems(cart, items) {
    if (!cart.items || cart.items.length === 0) {
      const data = document.querySelector('.cart-items__gtm [type="application/ld+json"]');
      const parsedData = data ? JSON.parse(data.innerText) : null;

      return items.map((item) => {
        const matchingParsedItem = parsedData?.ecommerce.items.find((parsedItem) => parsedItem.item_id === item.sku);

        const untranslated_product_title = matchingParsedItem ? matchingParsedItem.item_name : item.untranslated_product_title;
        const handle = matchingParsedItem ? matchingParsedItem.item_handle : item.handle;

        return {
          ...item,
          untranslated_product_title,
          handle,
          item_category: matchingParsedItem.item_category
        };
      });
    } else {
      return items.map((item) => {
        const matchingCartItem = cart.items.find(
          (cartItem) => cartItem.variant_id === item.variant_id
        );

        const untranslated_product_title = matchingCartItem ? matchingCartItem.untranslated_product_title : item.untranslated_product_title;
        const handle = matchingCartItem ? matchingCartItem.handle : item.handle;

        return {
          ...item,
          untranslated_product_title,
          handle,
        };
      });
    }
  }

  async productAdded(cartItems) {
    if (!cartItems.length) return;
    const items = [];
    let totalPrice = 0;

    const pushData = () => {
      const data = document.querySelector('.cart-items__gtm [type="application/ld+json"]');
      const parsedData = data ? JSON.parse(data.innerText) : null;

      cartItems.forEach((item, i) => {
        const matchedItem = parsedData?.ecommerce.items.find(
          (dataItem) => dataItem.item_id === item.sku
        );

        let price = Shopify.formatMoney(item.price, "{{amount}}");
        price = price * 1;
        totalPrice += price * item.quantity;
        items.push({
          item_id: item.sku,
          item_variant: item.variant_title,
          item_name: item.untranslated_product_title,
          item_handle: item.handle,
          item_category: matchedItem ? matchedItem.item_category : item.item_category,
          item_type: item.product_type,
          price: price,
          quantity: item.quantity,
        });
      });

      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "add_to_cart_custom",
        ecommerce: {
          value: parseInt(totalPrice),
          items: items,
        },
      });

      this.delegateBody.off('cart:render', pushData);
    }

    this.delegateBody.on('cart:render', pushData);
  }

  async productsRemoved(cartItems) {
    if (!cartItems.length) return;
    const items = [];
    let totalPrice = 0;

    const pushData = () => {
      const data = document.querySelector('.cart-items__gtm [type="application/ld+json"]');
      const parsedData = data ? JSON.parse(data.innerText) : null;

      cartItems.forEach((item, i) => {
        const matchedItem = parsedData?.ecommerce.items.find(
          (dataItem) => dataItem.item_id === item.sku
        );

        let price = Shopify.formatMoney(item.price, "{{amount}}");
        price = price * 1;
        totalPrice += price * item.quantity;
        items.push({
          item_id: item.sku,
          item_variant: item.variant_title,
          item_name: item.untranslated_product_title,
          item_handle: item.handle,
          item_category: matchedItem ? matchedItem.item_category : item.item_category,
          item_type: item.product_type,
          price: price,
          quantity: item.quantity,
        });
      });

      dataLayer.push({
        event: "remove_from_cart",
        remove: {
          value: totalPrice,
          items: items,
        },
      });

      this.delegateBody.off('cart:render', pushData);
    }

    this.delegateBody.on('cart:render', pushData);
  }

  handleSelectItem(event) {
    let target = event.target.closest('[data-action="ga-send-select"]');
    if (!target || !dataLayer) return;
    const settings = JSON.parse(target.dataset.selectSettings);
    if (!settings) return;

    dataLayer.push({
      event: "select_item",
      selected_item_list_id: settings.list_id,
      selected_item_list_name: settings.list_name,
      selected_items: [
        {
          item_id: settings.item_id,
          item_name: this.decodeHtmlEntities(settings.item_name),
          item_handle: settings.item_handle,
          item_category: settings.item_category,
          item_type: settings.item_type,
          price: settings.price,
          item_list_id: settings.list_id,
          item_list_name: settings.list_name,
        },
      ],
    });
  }

  decodeHtmlEntities(encodedString) {
    const parser = new DOMParser();
    const dom = parser.parseFromString(encodedString, "text/html");
    return dom.documentElement.textContent;
  }


  crawlAndDecode(obj, targetProperty) {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.crawlAndDecode(item, targetProperty));
    } else if (typeof obj === "object" && obj !== null) {
      for (const key in obj) {
        if (key === targetProperty && typeof obj[key] === "string") {
          obj[key] = this.decodeHtmlEntities(obj[key]);
        } else if (typeof obj[key] === "object") {
          obj[key] = this.crawlAndDecode(obj[key], targetProperty);
        }
      }
    }
    return obj;
  }
}
console.log('here');
if (!window.gTagEventsInstance) {
  window.gTagEventsInstance = new gTagEvents();
}
